























































































































































































import { Component, Vue } from 'vue-property-decorator';
import { VForm } from '@/@types';
import { notEmptyRules } from '@/@utils';

@Component
export default class LoginPage extends Vue {
  /* ------------------------------------
  => Local State Declaration
  ------------------------------------ */
  isRegister: boolean = false;
  validLogin: boolean = true;
  showLoginPassword: boolean = false;
  validRegister: boolean = true;
  showRegisterPassword: boolean = false;
  // Login data
  loginUsername: string = '';
  loginPassword: string = '';
  // Register data
  registerUsername: string = '';
  registerPassword: string = '';
  confirmPassword: string = '';
  registerDisplayName: string = '';

  /* ------------------------------------
  => Setter and Getter
  ** (Adopt store variables to local state)
  ------------------------------------ */
  get isLoading(): boolean {
    return this.$store.state.auth.isLoading;
  }

  /* ------------------------------------
  => Methods
  ------------------------------------ */
  changeFormType(type: string): void {
    const loginForm = this.$refs.loginForm as VForm;
    const registerForm = this.$refs.registerForm as VForm;
    if (type === 'login') {
      registerForm.reset();
      this.isRegister = false;
    } else {
      loginForm.reset();
      this.isRegister = true;
    }
  }

  doLogin(): void {
    const form = this.$refs.loginForm as VForm;
    if (form.validate()) {
      this.$store
        .dispatch('auth/login', {
          username: this.loginUsername,
          password: this.loginPassword
        })
        .then(async () => {
          await this.$router.push('/profile');
          form.reset();
        });
    }
  }

  doRegister(): void {
    const form = this.$refs.registerForm as VForm;
    if (form.validate()) {
      this.$store
        .dispatch('auth/register', {
          username: this.registerUsername,
          displayName: this.registerDisplayName,
          password: this.registerPassword
        })
        .then(async () => {
          this.isRegister = false;
          form.reset();
        });
    }
  }

  notEmpty(identifier: string): any[] {
    return notEmptyRules(identifier);
  }
}
